import Layout from "Avatar/Layout"

export { Layout }
